<template>
  <div id="header">
    <nav class="navbar navbar-expand-md bg-light navbar-light">
      <a class="navbar-brand" href="#">ESC</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="collapsibleNavbar">
        <ul class="navbar-nav">
          <li class="nav-item" v-if="!auth"><router-link to="/signin" class="nav-link">Sign in</router-link></li>
          <li class="nav-item" v-if="auth"><router-link to="/auswertung/gesamtsieger" class="nav-link">Gesamtsieger</router-link></li>
          <li class="nav-item" v-if="auth"><router-link to="/auswertung/geschlecht" class="nav-link">Je Geschlecht</router-link></li>
          <li class="nav-item" v-if="auth"><router-link to="/auswertung/ranking" class="nav-link">Je User</router-link></li>
          <li class="nav-item" v-if="auth"><router-link to="/auswertung/kategorie" class="nav-link">Je Kategorie</router-link></li>
          <li class="nav-item" v-if="auth"><router-link to="/auswertung/kategorie/M" class="nav-link">Je Kategorie (M)</router-link></li>
          <li class="nav-item" v-if="auth"><router-link to="/auswertung/kategorie/W" class="nav-link">Je Kategorie (W)</router-link></li>
          <li class="nav-item" v-if="auth"><router-link to="/userauswertung/userpunkte" class="nav-link">Punkte</router-link></li>
          <li class="nav-item" v-if="auth"><router-link to="/userauswertung/userlieblingskat" class="nav-link">Liebslingskat</router-link></li>
          <li class="nav-item" v-if="auth"><router-link to="/userauswertung/useraehnlich" class="nav-link">Ähnlich</router-link></li>
          <li class="nav-item" v-if="auth"><router-link to="/kommentarauswertung" class="nav-link">Kommentare</router-link></li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
  export default {
    computed: {
      auth() {
        return this.$store.getters.isAuthenticated;
      }
    }
  }
</script>
